// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"078e5445","544":"2f5a0636","756":"bb25b5e9","842":"94bd08de","973":"242e210f"}[chunkId] + ".chunk.js";
};